export const TableHr = () => <hr className="border border-secondary" />;
